<div *ngIf="libraries && !requestOtp && !repeatOtp" style="min-height: 210px">
  <div *ngIf="!credentialsCorrect">
    <p>Bitte überprüfen Sie Ihre Zugangsdaten.</p>
  </div>
  <ng-select
    focusInput
    class="form-control ng-select-white no-arrow"
    [(ngModel)]="login.library"
    [items]="libraries"
    placeholder="Bibliothek auswählen"
    disabled
    *ngIf="!IsTesting"
    (keydown.enter)="FormAutomation.FocusNextChild($event)"
  >
  </ng-select>
  <input
    type="text"
    autocomplete="off"
    [(ngModel)]="login.username"
    class="form-control"
    placeholder="Benutzername"
    (keydown.enter)="FormAutomation.FocusNextChild($event)"
    @inOutAnimation
  />
  <input
    type="password"
    [(ngModel)]="login.password"
    class="form-control"
    placeholder="Passwort"
    @inOutAnimation
    (keydown.enter)="execLogin(); FormAutomation.FocusNextChild($event)"
  />
  <div *ngIf="!isConnected">
    <p>
      Der Schulio-Server ist nicht erreichbar. Bitte überprüfen Sie Ihre
      Internet&shy;verbindung.
    </p>
  </div>
  <button
    id="submit"
    class="btn btn-block form-control"
    [class.d-none]="
      !login.username || (!login.library && !IsTesting) || !login.password
    "
    @inAnimation
    (click)="execLogin()"
    *ngIf="!loading"
    [disabled]="!isConnected"
  >
    Login & Cookies akzeptieren
  </button>
  <button
    id="loading"
    class="btn btn-block form-control"
    [class.d-none]="!login.username || !login.library || !login.password"
    @inAnimation
    disabled
    *ngIf="loading"
  >
    Lädt ...
  </button>
</div>
<div *ngIf="requestOtp">
  <div>
    <p>
      Bitte geben Sie das aktuelle
      {{ emailPasswordSupported ? "E-Mail" : "" }} Einmal-Passwort ein.
    </p>

    <div *ngIf="!credentialsCorrect">
      <p>Einmal-Passwort ungültig.</p>
    </div>

    <input
      type="text"
      pattern="[0-9]*"
      inputmode="numeric"
      [(ngModel)]="login.otp"
      class="form-control"
      placeholder="Einmal-Passwort"
      @inOutAnimation
      autocomplete="off"
      (keydown.enter)="execLogin(); FormAutomation.FocusNextChild($event)"
    />
  </div>

  <form-checkbox [(value)]="login.storeOtpHash" name="storeOtp"
    >Dieses Gerät merken</form-checkbox
  >

  <button
    id="submit"
    class="btn btn-block form-control"
    [class.d-none]="!login.otp"
    @inAnimation
    (click)="execLogin()"
    *ngIf="!loading"
    [disabled]="!isConnected"
  >
    Einmal-Passwort bestätigen
  </button>
  <button
    id="loading"
    class="btn btn-block form-control"
    [class.d-none]="!login.otp"
    @inAnimation
    disabled
    *ngIf="loading"
  >
    Lädt ...
  </button>

  <p style="margin-top: 2em" *ngIf="!emailPasswordSupported && !login.otp">
    <a
      (click)="requestEmailPassword()"
      style="text-decoration: underline; color: white; cursor: pointer"
      >Einmal-Passwort per E-Mail anfordern</a
    >
  </p>
</div>
<div *ngIf="repeatOtp">
  <div>
    <p>
      In {{ repeatOtpTime }} Tagen müssen Sie Ihr Einmal-Passwort auf diesem
      Gerät neu eingeben.
    </p>
  </div>

  <button
    id="repeatOtp"
    class="btn btn-block form-control"
    @inAnimation
    (click)="repeatOtp = false; requestOtp = true; login.storeOtpHash = true"
  >
    Einmal-Passwort jetzt neu eingeben
  </button>
  <button
    id="submit"
    class="btn btn-block form-control"
    @inAnimation
    (click)="execLogin(true)"
    *ngIf="!loading"
    [disabled]="!isConnected"
  >
    Weiter zu Schulio
  </button>
  <button
    id="loading"
    class="btn btn-block form-control"
    [class.d-none]="!login.otp"
    @inAnimation
    disabled
    *ngIf="loading"
  >
    Lädt ...
  </button>
</div>
